import { Exporter } from "./Exporter";

export default Exporter;
